export function getMaskRange(key) {
  var PresetRange = {
    YYYY: [0, 9999, new Date().getFullYear()],
    MM: [1, 12],
    DD: [1, 31],
    HH: [0, 23],
    mm: [0, 59],
    ss: [0, 59],
    SSS: [0, 999]
  };
  return PresetRange[key];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-picker/es/PickerInput/Selector/util.js
// module id = 3694
// module chunks = 0